// OverviewPage.tsx
import { Box, SxProps } from '@mui/material';
import React, { FunctionComponent } from 'react';
import SustainabilityContainer from '../sustainabilityPage/SustainabilityContainer';
import type { AboutInvestorRelationsOverviewContent } from '../../graphql/pimcore/modules/siteContent/types/AboutInvestorRelationsContent';
import OverviewTab from './OverviewTab';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { sanitizeRichText } from '../../graphql/pimcore/modules/siteContent/tools/sanitizeRichText';

export const buttonProps: SxProps = {
    padding: '4px 11px',
    gap: '10px',
    width: '13.5rem',
    height: '2.75rem',
    backgroundColor: '#E5673E',
    borderRadius: '5px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '36px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    transition: 'none',
    color: 'white',
    '&:hover': {
        background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
    },
};

interface OverviewPageProps {
    cmsContent: AboutInvestorRelationsOverviewContent;
}

const OverviewPage: FunctionComponent<OverviewPageProps> = ({ cmsContent }) => {
    const sanitizedMainText = sanitizeRichText(
        cmsContent.mainText.content,
        ['ul', 'li', 'a'],
        ['href']
    );
    return (
        <>
            <ResponsiveSplitSection
                textContent={
                    <Box
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            textAlign: 'left',
                            '& ul': {
                                paddingLeft: '2em',
                            },
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: sanitizedMainText }} />
                    </Box>
                }
                backgroundColor="white"
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                buttonText={cmsContent.stockQuoteLink.linkText}
                buttonHref={cmsContent.stockQuoteLink.linkUrl}
                buttonSx={buttonProps}
            />

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <OverviewTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default OverviewPage;
